import type { SVGProps } from 'react';

const SvgPortalNew = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      fill="currentcolor"
      d="M7.64 13.9q.66.18 1.35.18t1.35-.18l1.89-.53a.997.997 0 1 0-.54-1.92l-1.89.53c-.53.15-1.09.15-1.61 0l-5.46-1.53C2.3 10.33 2 9.93 2 9.49V6.24c0-.55.45-1 1-1h12c.55 0 1 .45 1 1V9c0 .55.45 1 1 1s1-.45 1-1V6.24c0-1.65-1.35-3-3-3h-1V3c0-1.65-1.35-3-3-3H7C5.35 0 4 1.35 4 3v.24H3c-1.65 0-3 1.35-3 3v3.25c0 .89.4 1.71 1.05 2.27-.02.08-.05.16-.05.25v3c0 1.65 1.35 3 3 3h5c.55 0 1-.45 1-1s-.45-1-1-1H4c-.55 0-1-.45-1-1v-2.4l4.65 1.3zM5.99 3c0-.55.45-1 1-1h4c.55 0 1 .45 1 1v.24h-6z"
    />
    <path
      fill="currentcolor"
      d="M6.99 8c-.55 0-1 .45-1 1s.45 1 1 1h4c.55 0 1-.45 1-1s-.45-1-1-1zM18.99 15h-2v-2c0-.55-.45-1-1-1s-1 .45-1 1v2h-2c-.55 0-1 .45-1 1s.45 1 1 1h2v2c0 .55.45 1 1 1s1-.45 1-1v-2h2c.55 0 1-.45 1-1s-.45-1-1-1"
    />
  </svg>
);
export default SvgPortalNew;
